var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 offset-1 col-sm-6 col-md-4 offset-sm-0 offset-md-1 text-center",attrs:{"id":"PsSiteSelection"}},[_c('Select',{attrs:{"label":"Site:","store":"PowerScan","name":"currentSite","options":_vm.siteOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }